import React, { useCallback } from "react";
import { v4 as uuid } from "uuid";
import { useDispatch } from "react-redux";

import { addModal, removeModal } from "../redux/actions/modalActions";

const createModalHandle = (ModalComponent, params, onClose) => {
  let resolver;

  const modalPromise = new Promise(resolve => {
    resolver = resolve;
  });

  const onResult = result => {
    onClose();
    resolver(result);
  };

  return {
    key: uuid(),
    content: <ModalComponent {...params} onResult={onResult} />,
    result: modalPromise
  };
};

const useModal = modalComponent => {
  const dispatch = useDispatch();

  const openModal = useCallback(
    params => {
      let handle;
      const onClose = () => {
        dispatch(removeModal(handle));
      };
      handle = createModalHandle(modalComponent, params, onClose);
      dispatch(addModal(handle));
      return handle;
    },
    [modalComponent]
  );

  return openModal;
};

export default useModal;
